import { SVGProps } from 'react';

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <g clipPath="url(#clip0_163503_19144)">
      <path
        fill="#686D7E"
        d="M13.25 11.5c-.251 0-.49.053-.706.148l-1.331-1.69a1.74 1.74 0 0 0 0-1.918l1.318-1.696A1.752 1.752 0 0 0 15 4.75C14.999 3.784 14.214 3 13.249 3c-.697 0-1.3.41-1.581 1H6.331c-.282-.59-.885-1-1.581-1C3.785 3 3 3.785 3 4.75c0 .697.41 1.3 1 1.582v5.338c-.59.282-1 .885-1 1.581 0 .965.785 1.75 1.75 1.75.697 0 1.3-.41 1.581-1h5.338c.282.59.885 1 1.582 1 .965 0 1.75-.785 1.75-1.75s-.785-1.75-1.75-1.75zM5 11.518V6.482A1.75 1.75 0 0 0 6.482 5h5.036c.036.25.125.484.256.689l-1.326 1.706A1.752 1.752 0 0 0 8 8.999a1.752 1.752 0 0 0 2.448 1.605l1.334 1.693a1.74 1.74 0 0 0-.265.702H6.482A1.75 1.75 0 0 0 5 11.518M10.5 9A.75.75 0 0 1 9 9a.75.75 0 0 1 1.5 0m2.75-5a.75.75 0 0 1 0 1.5.75.75 0 0 1 0-1.5m-8.5 0a.75.75 0 0 1 0 1.5.75.75 0 0 1 0-1.5m0 10a.75.75 0 0 1 0-1.5.75.75 0 0 1 0 1.5m8.5 0a.75.75 0 0 1 0-1.5.75.75 0 0 1 0 1.5"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_163503_19144">
        <path fill="#fff" d="M3 3h12v12H3z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default SvgIcon;
